/**
 * ステータス状態を表す要素（tbody > tr > td のセル内で使用）
 */

type Props = {
  label: string;
  active: boolean;
  color?: 'primary' | null;
};

const StatusTip = ({ label, active, color = null }: Props) => {
  return (
    <span
      className={`rounded border border-solid border-gray-200  px-3 py-[2px] text-sm
      ${active ? ' bg-white' : ' bg-gray-200'}
      ${color === 'primary' ? ' !border-primary-50 !bg-primary-50 ' : ' '}
    `}
    >
      {label}
    </span>
  );
};

export default StatusTip;
